// extracted by mini-css-extract-plugin
export var sharedContainer = "s53j0";
export var sharedIcon = "tnAYy";
export var sharedText = "egJ37";